import React, { useEffect, useMemo, useState } from 'react';
import api from '../../services/api';
import { dayLongLabel } from './AgendaResponsiveView';

function compactDate(dateStr) {
  if (!dateStr) return '';
  const [, month, day] = String(dateStr).split('-');
  return `${day}/${month}`;
}

export default function AgendaMobileOperationPicker({
  type,
  operationDate,
  onCancel,
  onConfirm,
}) {
  const [query, setQuery] = useState('');
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const title = type === 'desarmado' ? 'Agregar desarmado' : 'Agregar armado';
  const hint = type === 'desarmado'
    ? 'Eventos marcados en los 7 dias previos.'
    : 'Eventos marcados en los proximos 7 dias.';

  useEffect(() => {
    let alive = true;
    const timeout = window.setTimeout(async () => {
      setLoading(true);
      try {
        const { data } = await api.get('/event-operations/candidates', {
          params: { type, operation_date: operationDate, days: 7, q: query },
        });
        if (alive) setItems(Array.isArray(data) ? data : []);
      } catch {
        if (alive) setItems([]);
      } finally {
        if (alive) setLoading(false);
      }
    }, query ? 180 : 0);
    return () => {
      alive = false;
      window.clearTimeout(timeout);
    };
  }, [type, operationDate, query]);

  const copy = useMemo(() => ({
    empty: loading ? 'Buscando...' : 'No hay eventos candidatos.',
    action: type === 'desarmado' ? 'Crear desarmado' : 'Crear armado',
  }), [loading, type]);

  return (
    <div className="agm-sheet-backdrop" role="presentation" onClick={onCancel}>
      <section className="agm-action-sheet" role="dialog" aria-modal="true" onClick={event => event.stopPropagation()}>
        <header>
          <div>
            <p>{dayLongLabel(operationDate)}</p>
            <h2>{title}</h2>
            <small>{hint}</small>
          </div>
          <button type="button" onClick={onCancel} aria-label="Cerrar">×</button>
        </header>

        <label className="agm-sheet-search">
          <span>Buscar</span>
          <input value={query} onChange={event => setQuery(event.target.value)} placeholder="Evento, cliente, lugar..." />
        </label>

        <div className="agm-candidate-list">
          {items.length ? items.map(item => (
            <button
              key={item.id}
              type="button"
              className="agm-candidate-card"
              onClick={() => onConfirm(item)}
            >
              <span>
                <strong>{item.name}</strong>
                <small>{[item.place, item.client].filter(Boolean).join(' · ')}</small>
              </span>
              <em>{compactDate(item.event_date)}</em>
            </button>
          )) : (
            <p className="agm-candidate-empty">{copy.empty}</p>
          )}
        </div>

        <button type="button" className="agm-sheet-cancel" onClick={onCancel}>Cancelar</button>
      </section>
    </div>
  );
}
